import { dateParser } from '@/pages/reports/non-ats-reports/shared/dateParser';

const METRICS = {
  contacted: { index: 4, name: 'Sent', color: '#F72585' },
  opened: { index: 5, name: 'Opened', color: '#6930C3' },
  replied: { index: 6, name: 'Replied', color: '#4361EE' },
  interested: { index: 7, name: 'Interested', color: '#4CA1F0' },
};

const createDataPoint = (current, compare = null) => ({
  y: current || 0,
  ...(compare !== null && { c: compare || 0 }),
});

const processChartData = (chartData, compareData = null) => {
  const result = Object.keys(METRICS).reduce((acc, metric) => {
    acc[metric] = [];
    return acc;
  }, {});

  chartData.forEach((curr, index) => {
    Object.entries(METRICS).forEach(([metric, { index: dataIndex }]) => {
      const compareValue = compareData?.[index]?.[dataIndex];
      result[metric].push(createDataPoint(curr[dataIndex], compareValue));
    });
  });

  return result;
};

const createSeries = (data) =>
  Object.entries(METRICS).map(([metric, { name, color }]) => ({
    name,
    data: data[metric],
    color,
  }));

export const flowCandidateTouchPointTransformer = ({ response, args }) => {
  const { chart = [], lookups, compare_date } = response || {};
  const { dt } = lookups || {};
  const { date_group } = args || {};

  const hasCompare = compare_date?.from || compare_date?.to;
  const categories = dateParser(dt, date_group);

  if (!hasCompare) {
    const data = processChartData(chart);
    return { categories, series: createSeries(data), flowdt: dt };
  }

  const dataSet = chart.filter((d) => d[0] === '0');
  const compareDataSet = chart.filter((d) => d[0] === '1');
  const data = processChartData(dataSet, compareDataSet);

  return { categories, series: createSeries(data), flowdt: dt };
};
